import React, { useMemo } from "react";
import HighChart from "../../components/ui/BaseChart";

const STATUS_COLORS = {
  Drafted: "#C0B023",
  Published: "#FF5F00",
  Assigned: "#2561A9",
  "In-Progress": "#FF9800",
  "Work Done": "#295E80",
  "In-Complete": "#C44336",
  Approved: "#268E2A",
  Verified: "#279AA0",
  Invoiced: "#abff10",
  Paid: "#0F40AE",
  Cancelled: "#F44336",
};

const WorkOrderDonut = ({ data }) => {
  const seriesData = useMemo(() => {
    if (!data) return [];
    return data
      .filter((d) => d.y > 0)
      .map((d) => ({ ...d, color: STATUS_COLORS[d.name] ?? "#90A4AE" }));
  }, [data]);

  const total = seriesData.reduce((s, d) => s + d.y, 0);

  const chartOptions = useMemo(
    () => ({
      chart: {
        type: "pie",
        height: 400,
        margin: [10, 10, 70, 10],
        events: {
          render() {
            const chart = this;
            const center = chart.series?.[0]?.center;
            if (!center) return;
            const x = chart.plotLeft + center[0];
            const y = chart.plotTop + center[1];
            if (chart._ct) {
              chart._ct.attr({ text: String(total), x, y: y - 6 });
              chart._cs.attr({ x, y: y + 14 });
            } else {
              chart._ct = chart.renderer
                .text(String(total), x, y - 6)
                .css({ fontSize: "28px", fontWeight: "700", color: "#222" })
                .attr({ align: "center", zIndex: 5 })
                .add();
              chart._cs = chart.renderer
                .text("Work Orders", x, y + 14)
                .css({ fontSize: "11px", color: "#888" })
                .attr({ align: "center", zIndex: 5 })
                .add();
            }
          },
        },
      },
      title: { text: null },
      tooltip: { pointFormat: "<b>{point.name}</b>: {point.y}" },
      plotOptions: {
        pie: {
          innerSize: "55%",
          dataLabels: {
            enabled: true,
            formatter() {
              return `<b>${this.y}</b><br/><span style="color:${this.color};font-weight:600;font-size:10px">${this.point.name}</span>`;
            },
            distance: 25,
            style: { fontSize: "11px", textOutline: "none" },
            connectorWidth: 1,
            connectorColor: "#bbb",
          },
          showInLegend: true,
        },
      },
      legend: {
        layout: "horizontal",
        align: "center",
        verticalAlign: "bottom",
        itemStyle: { fontSize: "10px", fontWeight: "normal", color: "#555" },
        symbolRadius: 2,
        itemDistance: 12,
        margin: 8,
        padding: 4,
        labelFormatter() {
          return `${this.name}: ${String(this.y).padStart(2, "0")}`;
        },
      },
      series: [{ name: "Work Orders", data: seriesData, borderWidth: 2 }],
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [seriesData, total],
  );

  return <HighChart options={chartOptions} className="w-full" />;
};

export default WorkOrderDonut;
